<div *ngIf="showSection" class="responsive-card d-flex flex-column gap-4">
  <div class="responsive-card-title" i18n>Lump Sum Details</div>

  <ng-container *ngIf="isUnchanged; else comparisonView">
    <ng-container *ngTemplateOutlet="cardContent; context: { card: newCard }" />
  </ng-container>

  <ng-template #comparisonView>
    <div class="d-flex flex-column gap-3">
      <span class="label-sm" i18n>Current</span>
      <ng-container *ngTemplateOutlet="cardContent; context: { card: currentCard, isCurrentState: true }" />
    </div>
    <div class="d-flex flex-column gap-3">
      <span class="label-sm" i18n>New</span>
      <ng-container *ngTemplateOutlet="cardContent; context: { card: newCard, isNewState: true }" />
    </div>
  </ng-template>
</div>

<ng-template #cardContent let-card="card" let-isCurrentState="isCurrentState" let-isNewState="isNewState">
  <div class="inner-card d-flex flex-column gap-4" [class.current]="isCurrentState" [class.new]="isNewState">
    <div *ngIf="card.isEmpty; else paymentDetails" class="payment-date" i18n>No lump sum payments</div>

    <ng-template #paymentDetails>
      <div class="payment-date" i18n>Payment on {{ card.paymentDate | date : 'MMMM d, yyyy' }}</div>
      <div class="d-flex flex-column gap-3">
        <ng-container *ngFor="let row of card.rows; let last = last">
          <div class="payment-row">
            <div class="d-flex align-items-center gap-2">
              <span class="paragraph-lg">{{ row.jurisdictionName }}</span>
              <span *ngIf="row.isNew" class="new-pill" i18n>New</span>
            </div>
            <div class="row-amount">{{ row.amount | currency }}</div>
          </div>
          <hr *ngIf="!last" class="m-0" />
        </ng-container>
        <hr class="m-0" />
      </div>
      <div class="total-row">
        <span i18n class="lump-sum-total-header">Lump Sum Payments Total:</span>
        <span class="total-amount">{{ card.total | currency }}</span>
      </div>
    </ng-template>
  </div>
</ng-template>
